// extracted by mini-css-extract-plugin
module.exports = {"wxtjzt":"wxtjzt","chat-container":"chat-container","szewrc":"szewrc","c13r3m4c":"c13r3m4c","cwr93eb":"cwr93eb"};